<template>
  <div id="t3m-Flx" class="overflow-hidden bg-gray-900 t3m-Flx" :class="{ isMobile: isMobile() }">
    <billboard />
    <v-section v-for="s in sections" :key="s.id" v-bind="s" />
  </div>
</template>

<script>
import { utilities } from "@/shared";
import { mapState, mapActions } from "vuex";
import Billboard from "@/components/Billboard.vue";
import VSection from "@/components/VSection.vue";

export default {
  name: "App",
  components: {
    VSection,
    Billboard,
  },
  mixins: [utilities],
  computed: {
    ...mapState(["sections", "selectedCard"]),
  },
  methods: {
    ...mapActions(["loadAllData"]),
  },
  mounted() {
    document.documentElement.classList.add("has-flx");

    const h1 = document.querySelectorAll(".t3m-Section--intro h1");
    h1.forEach(h => {
      let h2 = document.createElement("h2");
      h2.innerText = h.innerText;
      h.parentNode.replaceChild(h2, h);
    });

    this.loadAllData();
  },
};
</script>

